import React from "react";
import { dataSetIds } from "../utils/Data.js";
import DropDown from "./DropDown";

const Header = ({ brandChangeHandler }) => {
  return (
    <div className="sticky z-50 top-0 flex items-center w-full border-b border-zinc-800 py-4">
      <h2 className="w-1/2 pl-2 font-semibold">HectorGPT</h2>
      <div className="w-1/2 flex justify-end pr-4 gap-3 items-center">
        <DropDown options={dataSetIds} handleClick={brandChangeHandler} />
      </div>
    </div>
  );
};

export default Header;
